import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Component, OnInit, ViewChild } from '@angular/core';
import { Component, OnInit, ViewChild,Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-state-dialog-box',
  templateUrl: './state-dialog-box.component.html',
  styleUrls: ['./state-dialog-box.component.scss']
})
export class StateDialogBoxComponent implements OnInit {
  displayColumns = [ 'StateCode', 'StateName'];
  StateForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  stateList: any;
  isreadonlydel = false;
  state: string;
  list;
  stateform: any;
  StateSearchForm;
  APIService: any;
  deleteButton: boolean;
  StateCodefordelete;
  isreadonly = false;
  Add = true;
  Update = false;
  Delete = false;
  dialogRef: MatDialogRef<any>;
  CountryCodeList: any;
  filteredListCountryCode: any;
  userPermission:any;
  utp: any;
  stateCreate = true;
stateUpdate = true;
stateDelete = true;
  constructor(public umsService: UmsService,private dialogRef2:MatDialogRef<StateDialogBoxComponent>,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
              private fb: FormBuilder,   public router: Router, private httpClient: HttpClient,
              private route: ActivatedRoute, private spinner:NgxSpinnerService, ) {this.APIService = environment.serviceUrl; }

  download(){
    const wwe = ['StateCode', 'StateName'];
    this.umsService.downloadFile(this.stateList, 'jsontocsv', wwe);
  }
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
  this.utp = sessionStorage.getItem('usertypeee');
  if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
    // this.isSuperAdmin= false;
    this.userPermission.forEach(element => {
    if(element.PageName == 'State' && element.PCreate == false)
    {
        this.stateCreate = false;  
    }
    if(element.PageName == 'State' && element.PUpdate == false)
    {
        this.stateUpdate = false;  
    }   
    if(element.PageName == 'State' && element.PDelete == false)
    {
        this.stateDelete = false;  
    } 
  });
}
    window.scroll(0, 0);
    let id = '';
    this.StateCodefordelete = 0;
    this.submitButton = true;
    this.editButton = false;
    this.Add = true;
    this.Update = false;
    this.Delete = false;
    this.getStateData();
    this.fetchCountryCode(id);
    this.list = true;
    this.StateForm = this.fb.group({

      StateCode: new FormControl('',  [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
      StateName: new FormControl('', [Validators.required]),
      CountryCode: new FormControl('', [Validators.required]),
      

    });
    this.StateSearchForm = this.fb.group({
      SearchString: new FormControl ('')
    });
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
    } else {
      // alert(this.data.key) 
    }
  }

  getStateData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getState(payload).subscribe(res => {
      this.stateList = res.data;
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.stateList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  prepopulation(id) {
    this.isreadonly = true;
    this.isreadonlydel = false;
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.Update = true;
    this.Add = false;
    this.Delete = false;
    this.StateForm = this.fb.group({
      StateCode: new FormControl(id.StateCode, [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
      StateName: new FormControl(id.StateName, [Validators.required]),
      CountryCode: new FormControl(id.CountryCode, [Validators.required]),
      // CountryName: new FormControl(data.CountryName, [Validators.required]),

    });
  }

  deletedata(id){
    const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),  body: {
      StateName: id.StateName,
      StateCode: id.StateCode,
      CountryCode: id.CountryCode

    },
  };
    this.httpClient.delete(this.APIService + '/masters/state', options)
    .subscribe((s) => {
      // this.spinner.hide();
      let cc = [];
      cc.push(s);
      let  data = {}
      data['message'] = cc[0].message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        // this.ngOnInit();
        this.dialogRef2.close();
      });
    },(ERROR: HttpErrorResponse) => {

      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

   });

   }

   deletee(e, k,) {
    if (e === 'true') {
      this.list = false;
      // this.getExamDivData(id);
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }


  prepopulationForDelete(data){
    this.editButton = false;
    this.submitButton = false;
    this.isreadonlydel = true;
    this.isreadonly = false;
    this.deleteButton = true;
    this.Delete = true;
    this.Add = false;
    this.Update = false;
    this.StateForm = this.fb.group({
      StateCode: new FormControl(data.StateCode, [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
      StateName: new FormControl(data.StateName, [Validators.required]),
      CountryCode: new FormControl(data.CountryCode, [Validators.required]),
      // CountryName: new FormControl(data.CountryName, [Validators.required]),
      
    });
    this.StateCodefordelete =  this.StateForm.value;
  }
  openConformationModalBox(){
    let  data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if(result == 'yes'){
        this.deletedata(this.StateCodefordelete);
      }else{
        // this.ngOnInit();
      } 
    });
   }

  keypress(){
    this.umsService.searchState(this.StateSearchForm.value).subscribe(res => {
      this.stateList = res.data;
      }, (ERROR: HttpErrorResponse) => {
        this.stateList = [];
      });
  }

  submit() {
    if (this.StateForm.invalid) {
      this.StateForm.get('StateCode').markAsTouched();
      this.StateForm.get('StateName').markAsTouched();
      this.StateForm.get('CountryCode').markAsTouched();
      return;
    } else {
      this.createState();
    }

  }

  createState() {
    this.spinner.show();
    this.submitpayload = this.StateForm.value;
    this.umsService.addState(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.stateList = [];
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
   });
  }

  update() {
    if (this.StateForm.invalid) {      
      this.StateForm.get('StateCode').markAsTouched();
      this.StateForm.get('StateName').markAsTouched();
      this.StateForm.get('CountryCode').markAsTouched();
      return;
    } else {
      this.updateState();
    }
  }

  updateState() {
    this.spinner.show();
    let id = '';
    this.fetchCountryCode(id);
    this.submitpayload = this.StateForm.value;
    this.umsService.updateState(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
         // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
         // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     
   });
  }

  addnewrecord(e){
    if (e === 'true'){
      this.list = false;
      this.submitButton = true;
      this.editButton = false;
      this.deleteButton = false;
      this.Add = true;
      this.Update = false;
      this.Delete = false;
      this.isreadonly = false;
      this.isreadonlydel = false;
      this.StateForm.reset();
      // this.StateForm = this.fb.group({
      //   StateCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-z0-9]*$')]),
      //   StateName: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),
      //   CountryCode: new FormControl('', [Validators.required]),
        
      // });
    } else {
      this.list = true;
      this.submitButton = false;
      // this.isreadonly = true;
      this.editButton = true;
      // this.isreadonlydel = true;
      this.deleteButton = true;
      this.getStateData();
      this.ngOnInit();
    }
  }

  editdata(e, k){
    if (e === 'true'){
      this.list = false;
      // this.getStateData();
      // this.StateForm = k;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
   }

   fetchCountryCode(id) {
    const payload = {};
    payload['CountryCode'] = id;
    payload['CountryName'] = id;
    this.umsService.getCountry(payload).subscribe(res => {
      if (res.status) {    
        this.CountryCodeList = res.data;
        this.filteredListCountryCode= this.CountryCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  } 



 
}

  
